import "../../../../stylesheets/campaign";
import "../../../../stylesheets/events";
import "../../../../stylesheets/templates/events/template-1";
import "../../../../stylesheets/accounts/base";
import "./index";
import { validateEmail } from "../../utils";
import { format, validate } from "rut.js";

$(document).ready(function () {
  $(".event-inscriptions").on("click", ".collapse-btn", function (e) {
    const collapse_index = $(this).data("index");
    collapseOpenInscriptions(collapse_index);
  });

  $(".event-inscriptions").on("input", ".email-field", function (e) {
    this.value = this.value.replaceAll(" ", "");
  });

  $(".addInscription").on("click", function (e) {
    let lastInscription = $(".event-inscriptions .row-inscription").length;
    e.preventDefault();
    const row = $(".event-inscriptions .row-inscription").prop("outerHTML");
    replaceInscriptionIndex(lastInscription, row, this.dataset["name"]);
    $(
      `.event-inscriptions .row-inscription[data-index="${lastInscription}"] .btn-delete`
    ).css("display", "block");
    $(
      `.event-inscriptions .row-inscription[data-index="${
        lastInscription - 1
      }"] .inscription-headers`
    ).css("display", "flex");
    $(
      `.event-inscriptions .row-inscription[data-index="${lastInscription}"] .inscription-headers`
    ).css("display", "flex");
    if (
      !(
        $(`#collapseInscription${lastInscription}`)[0].classList.contains(
          "show"
        ) == true
      )
    ) {
      collapseOpenInscriptions(lastInscription);
    }
    if (
      $(`#collapseInscription${lastInscription - 1}`)[0].classList.contains(
        "show"
      ) == true
    ) {
      collapseOpenInscriptions(lastInscription - 1);
    }
    formatSelectFields();
    calculateAmount();
    $(".event-inscriptions")[0].scrollIntoView();
  });

  $(".event-inscriptions").on("click", ".btn-delete", function (e) {
    e.preventDefault();
    const index = $(this).data("index");
    if (!index) return;
    $(`.row-inscription[data-index="${index}"]`).remove();
    let lastInscription = $(".event-inscriptions .row-inscription").length;
    let new_price =
      parseInt($("#original-event-price")[0].value) * lastInscription;
    $("#donator_donation_transactions_attributes_0_amount")[0].value =
      new_price;
    $(".event-price")[0].value = new Intl.NumberFormat("es-CL", {
      currency: "CLP",
      style: "currency",
    }).format(new_price);
  });

  $(".event-inscriptions").on("input", ".email-field-input", function (e) {
    var id = this.id.split("-").slice(-1)[0];
    this.value = this.value.replaceAll(" ", "");
    validateEmail(`email-${id}`, `email-confirmation-${id}`);
  });

  $(".event-inscriptions").on("input", ".tax_id_input", function (e) {
    let val = format(this.value);
    this.value = val;
  });

  $(".event-inscriptions").on("blur", ".tickets-quantity-input", function (e) {
    calculateAmount();
  });

  // Currency selector
  $(".currency-selection label").click(({ target }) => {
    $("#currency-type")[0].value = target.getAttribute("data-currency");
    calculateAmount();
  });

  $(".product-type-selector").on("change", function (e) {
    const noProductFields = document.querySelectorAll(
      `[data-product]:not([data-product="${this.value}"]):not([data-product=""])`
    );
    for (var i = 0; i < noProductFields.length; i++) {
      noProductFields[i].required = false;
      noProductFields[
        i
      ].parentElement.parentElement.parentElement.classList.add("d-none");
      noProductFields[
        i
      ].parentElement.parentElement.parentElement.classList.remove("d-flex");
    }
    const productFields = document.querySelectorAll(
      `[data-product="${this.value}"]`
    );
    for (var i = 0; i < productFields.length; i++) {
      productFields[i].required = productFields[i].dataset["req"] === "true";
      productFields[i].parentElement.parentElement.parentElement.classList.add(
        "d-flex"
      );
      productFields[
        i
      ].parentElement.parentElement.parentElement.classList.remove("d-none");
    }
    let new_product_price =
      document.querySelectorAll(`[name="product_price['${this.value}']"`)[0]
        ?.value || "0";
    let new_product_price_usd =
      document.querySelectorAll(`[name="product_price_usd['${this.value}']"`)[0]
        ?.value || "0";
    $("#original-event-price")[0].value = new_product_price;
    $("#original-event-price-usd")[0].value = new_product_price_usd;
    $("#donator_donation_transactions_attributes_0_product_id")[0].value =
      this.value;
    calculateAmount();
  });
});

const collapseOpenInscriptions = (index) => {
  if ($(`#collapseInscription${index}`)[0].classList.contains("show") == true) {
    $(`#collapseInscription${index}`)[0].classList.remove("show");
  } else {
    $(`#collapseInscription${index}`)[0].classList.add("show");
  }
};

const replaceInscriptionIndex = (index, row, inscription_name) => {
  $(".event-inscriptions").append(
    row
      .replaceAll('data-index="0"', `data-index="${index}"`)
      .replaceAll("[0]", `[${index}]`)
      .replaceAll(`${inscription_name} 1`, `${inscription_name} ${index + 1}`)
      .replaceAll("collapseInscription0", `collapseInscription${index}`)
      .replaceAll("email-0", `email-${index}`)
      .replaceAll("email-confirmation-0", `email-confirmation-${index}`)
      .replaceAll("is-valid", "")
      .replaceAll("is-invalid", "")
      .replaceAll("inscription_0", `inscription_${index}`)
  );
};

const formatSelectFields = () => {
  $(".select2-field")?.select2();
  $(".select2-container").each(function () {
    if ($(this).next().hasClass("select2-container")) {
      $(this).next().remove();
    }
  });
};

const calculateAmount = () => {
  let product_price = $("#currency-type")[0].value == 'usd' ? $("#original-event-price-usd")[0].value : $("#original-event-price")[0].value
  let total_inscriptions = 0;
  let inscriptions_input = $(".event-inscriptions .tickets-quantity-input");
  for (var i = 0; i < inscriptions_input.length; i++) {
    total_inscriptions += parseInt(inscriptions_input[i].value);
  }
  let new_price = parseInt(product_price) * total_inscriptions;
  $("#donator_donation_transactions_attributes_0_amount")[0].value = new_price;
  $(".event-price")[0].value = new Intl.NumberFormat("es-CL", {
    currency: "CLP",
    style: "currency",
  }).format(new_price);
};
